import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-archiving-button',
  templateUrl: './archiving-button.component.html',
  styleUrls: ['./archiving-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class ArchivingButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
